import axios from 'axios';
import { BASE_URL } from '../../Constants/constants';


export const dutyStationService = {
    // Get all duty stations
    async getDutyStations() {
        const response = await axios.get(`${BASE_URL}/duty_stations/`);
        return response.data;
    },

    // Get duty stations for dropdown
    async getDutyStationsForDropdown() {
        const response = await axios.get(`${BASE_URL}/duty_stations/dropdown`);
        return response.data;
    },

    // Get a specific duty station by ID
    async getDutyStation(dutyStationId) {
        const response = await axios.get(`${BASE_URL}/duty_stations/${dutyStationId}`);
        return response.data;
    },

    // Create a new duty station
    async createDutyStation(dutyStationData) {
        const response = await axios.post(`${BASE_URL}/duty_stations/`, dutyStationData);
        return response.data;
    },

    // Update a duty station
    async updateDutyStation(dutyStationId, dutyStationData) {
        const response = await axios.put(`${BASE_URL}/duty_stations/${dutyStationId}`, dutyStationData);
        return response.data;
    },

    // Delete a duty station
    async deleteDutyStation(dutyStationId) {
        const response = await axios.delete(`${BASE_URL}/duty_stations/${dutyStationId}`);
        return response.data;
    },

    // Update duty station status
    async updateDutyStationStatus(dutyStationId, isActive) {
        const response = await axios.patch(`${BASE_URL}/duty_stations/${dutyStationId}/status`, { is_active: isActive });
        return response.data;
    }
};